import { render, staticRenderFns } from "./KnowledgeBaseArticleForm.vue?vue&type=template&id=071386d8&scoped=true"
import script from "./KnowledgeBaseArticleForm.vue?vue&type=script&lang=ts"
export * from "./KnowledgeBaseArticleForm.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeBaseArticleForm.vue?vue&type=style&index=0&id=071386d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071386d8",
  null
  
)

export default component.exports